import { render, staticRenderFns } from "./WhButtonRadioGroup.vue?vue&type=template&id=1d5dbf6e&scoped=true&"
import script from "./WhButtonRadioGroup.vue?vue&type=script&lang=js&"
export * from "./WhButtonRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./WhButtonRadioGroup.vue?vue&type=style&index=0&id=1d5dbf6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5dbf6e",
  null
  
)

export default component.exports